import { InfoIcon } from 'components/Icons';

import { ProjectInfoModal } from './ProjectInfoModal';

import { registerProjectOption } from '../options';

export default registerProjectOption({
  Icon: InfoIcon,

  getLabel: (t) => t('details'),

  modal: 'DETAILS',
  overlay: ProjectInfoModal,

  shortcut: {
    key: 'D',
    triggerKey: ['ctrl'],
  },

  useOption: ({ openModal }) => ({
    action: () => openModal('DETAILS'),
    isEnabled: true,
  }),
});
